import React from 'react';
import classNames from 'classnames/bind';
import {
    TagOutlined,
    CalendarOutlined,
    UserOutlined,
    ArrowRightOutlined,
    GithubOutlined,
    GlobalOutlined,
    YoutubeOutlined,
    HomeOutlined,
    BankOutlined,
    TeamOutlined,
} from '@ant-design/icons';
import { Home, Briefcase, Users } from 'lucide-react';
import styles from './ProjectCard.module.scss';

const cx = classNames.bind(styles);

function ProjectCard({ project, delay = 0 }) {
    const {
        title,
        shortDescription,
        thumbnail,
        category,
        tags,
        completedDate,
        client,
        role,
        previewLink,
        youtubeLink,
        githubLink,
        type, // thêm thuộc tính type để nhận biết loại dự án
    } = project;

    // Chỉ hiển thị tối đa 3 tags
    const displayTags = tags.slice(0, 3);
    const remainingTags = tags.length > 3 ? tags.length - 3 : 0;

    // Xác định loại dự án và icon tương ứng
    const getProjectTypeInfo = () => {
        switch (type) {
            case 'personal':
                return {
                    label: 'Cá nhân',
                    className: 'personal',
                    icon: <Home size={12} className={cx('badge-icon')} />,
                };
            case 'team':
                return {
                    label: 'Nhóm',
                    className: 'team',
                    icon: <Users size={12} className={cx('badge-icon')} />,
                };
            case 'company':
                return {
                    label: 'Công ty',
                    className: 'company',
                    icon: <Briefcase size={12} className={cx('badge-icon')} />,
                };
            default:
                return {
                    label: 'Dự án',
                    className: '',
                    icon: null,
                };
        }
    };

    const projectTypeInfo = getProjectTypeInfo();

    return (
        <div className={cx('project-card')} style={{ animationDelay: `${delay}s` }}>
            <div className={cx('card-thumbnail')}>
                <div className={cx('category-badge')}>{category}</div>

                {/* Badge hiển thị loại dự án */}
                <div className={cx('project-type-badge', projectTypeInfo.className)}>
                    {projectTypeInfo.icon}
                    <span>{projectTypeInfo.label}</span>
                </div>

                <img src={thumbnail || '/images/projects/placeholder.jpg'} alt={title} />
            </div>

            <div className={cx('card-content')}>
                <h3 className={cx('project-title')}>{title}</h3>
                <p className={cx('project-description')}>{shortDescription}</p>

                <div className={cx('project-meta')}>
                    <div className={cx('meta-item')}>
                        <CalendarOutlined className={cx('meta-icon')} />
                        <span>{completedDate}</span>
                    </div>

                    <div className={cx('meta-item')}>
                        <UserOutlined className={cx('meta-icon')} />
                        <span>{role}</span>
                    </div>
                </div>

                <div className={cx('project-tags')}>
                    <TagOutlined className={cx('tags-icon')} />
                    {displayTags.map((tag, index) => (
                        <span key={index} className={cx('tag')}>
                            {tag}
                        </span>
                    ))}
                    {remainingTags > 0 && <span className={cx('tag', 'more-tag')}>+{remainingTags}</span>}
                </div>

                <div className={cx('card-footer')}>
                    <div className={cx('view-details')}>
                        <span>Xem chi tiết</span>
                        <ArrowRightOutlined className={cx('arrow-icon')} />
                    </div>

                    <div className={cx('link-buttons')}>
                        {githubLink && (
                            <a
                                href={githubLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={cx('link-button', 'github')}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <GithubOutlined />
                            </a>
                        )}

                        {youtubeLink && (
                            <a
                                href={youtubeLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={cx('link-button', 'youtube')}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <YoutubeOutlined />
                            </a>
                        )}

                        {previewLink && (
                            <a
                                href={previewLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={cx('link-button', 'preview')}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {previewLink.includes('youtube') ? <YoutubeOutlined /> : <GlobalOutlined />}
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProjectCard;
